import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import moment from "moment";
import { DateTimeHelper } from '../../utils/DateTimeHelper.util';

@Component
class DatePickerRange extends Vue {
  @Prop({
    default: null, type: [String, Array, Date]
  })
  customClass: string | string[]

  @Prop({ default: null, type: [String] })
  format: string;

  @Prop({ default: () => ({ startDate: new Date().setDate(-30), endDate: new Date() }) })
  value: { startDate: Date | string, endDate: Date | string }

  dtMenu1: boolean;
  dtMenu2: boolean;
  /**
   *
   */
  constructor() {
    super();
    this.dtMenu1 = false;
    this.dtMenu2 = false;
  }

  get coLocale(): string {
    return this.$i18n.locale;
  }
  get startDateString(): string {
    if (this.format)
      return moment(this.startDate).format(this.format)
    else return DateTimeHelper.parseDate(this.startDate)
  }
  get endDateString(): string {
    if (this.format)
      return moment(this.endDate).format(this.format)
    else return DateTimeHelper.parseDate(this.endDate)
  }
  get startDate(): Date | string {
    return this.value.startDate;
  }
  set startDate(start: Date | string) {
    this.$emit('input', { ...this.value, startDate: start })
  }
  get endDate(): Date | string {
    return this.value.endDate;
  }
  set endDate(end: Date | string) {
    this.$emit('input', { ...this.value, endDate: end })
  }

  @Emit('change')
  handleChange(event) {
  }
}

export default DatePickerRange;


// WEBPACK FOOTER //
// ./src/components/date-picker-range/index.ts